<template>
	<div
		:aria-selected="selected"
		:class="[{selected: selected}]"
		role="menuitemradio"
		class="menu-option-item"
		tabindex="0"
		@click="onSelect"
		@keydown.space.prevent="onSelect"
	>
		<div class="menu-option-item-icon-wrapper">
			<t-timpex-icon
				v-show="selected"
				:class="[{selected: selected}]"
				icon="tick"
				size="sm"
				type="bp"
				class="menu-option-item-icon"
			/>
		</div>
		<span :class="[{selected: selected, bold: bold, focused: focused}]" class="menu-option-item-inner">
			<slot>{{value}}</slot>
		</span>
	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import menuOptionItemMixin from './menuOptionItemMixin';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuOptionItem',
	components: { TTimpexIcon },
	mixins: [ menuItemMixin, menuOptionItemMixin ],
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-option-item {
		@extend %font-families-ui;
		@extend %text-default;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&.selected {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&.focused {
			background-color: rgba(16, 112, 202, 0.04);
		}
		&:hover {
			background-color: rgba(67, 90, 111, 0.04);
		}
		&:active {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:focus {
			background-color: rgba(16, 112, 202, 0.04);
		}
	}

	.menu-option-item-icon-wrapper {
		display: flex;
		justify-content: center;
	}

	.menu-option-item-icon {
		color: get-color($icon, 'default');
		margin-left: 18px;
		margin-right: -6px;
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base');
		}
	}

	.menu-option-item-inner {
		flex:1;
		height: 32px;
		font-weight: 400;
		font-size: 12px;
		line-height: 32px;
		margin-left: 0;
		margin-right: 0;
		border-bottom: 1px solid rgb(237, 240, 242);
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base');
		}
		&.bold {
			font-weight: 500;
		}
	}
</style>
